module.exports = __webpack_public_path__ + "img/02.b3c97886.jpg";